import type { ApiResponse } from '@/shared/types';
import api from '@/shared/api/client';

export const operatorOpsApi = {
  getDashboard: () => api.get<ApiResponse<any>>('/operator/ops/dashboard'),
};
